import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { periodicidadeTodoPeriodo } from '../../../../../shared';
import { TituloReceberAuthGuardService, TituloReceberReportHttpService } from '../../../../titulo-receber';
import { TituloReceberFilter, TituloReceberFilterComponent, TituloReceberFilterInitialization, TituloReceberFilterStorageService } from '../../../../titulo-receber/filter';
import { TituloReceberFormModalComponent } from '../../../../titulo-receber/form/modal';
import { TituloReceberResourceOptions } from '../../../../titulo-receber/titulo-receber-resource-options';
import { TituloReceberSearch } from '../../../../titulo-receber/titulo-receber-search';
import { TituloReceberTableComponent } from '../../../../titulo-receber/view/table';

@Component({
    selector: 'sgt-cliente-titulo-receber-view',
    templateUrl: './cliente-titulo-receber-view.component.html',
    styleUrls: ['./cliente-titulo-receber-view.component.less']
})
export class ClienteTituloReceberViewComponent implements OnInit, OnDestroy {
    readonly filterStorageKey = 'clienteTituloReceberViewFilter';
    readonly visualizacaoStorageKey = 'clienteTituloReceberViewVisualizacao';
    options: TituloReceberResourceOptions;

    // Filter
    /** Filtro das pessoas dos títulos a receber */
    @Input() idsPessoasFilter: number[] = [];
    filter = new TituloReceberFilter(periodicidadeTodoPeriodo);
    filterInitialization = new TituloReceberFilterInitialization();
    @ViewChild('tituloReceberFilter') tituloReceberFilter: TituloReceberFilterComponent;

    // Table
    @ViewChild('table') table: TituloReceberTableComponent;

    // Form
    @ViewChild('formModal') formModal: TituloReceberFormModalComponent;

    constructor(private tituloReceberAuthGuardService: TituloReceberAuthGuardService,
                private tituloReceberFilterStorageService: TituloReceberFilterStorageService,
                private tituloReceberReportHttpService: TituloReceberReportHttpService) { }

    ngOnInit(): void {
        this.initFilter();
        this.createOptions();
    }

    /** Cria as opções disponíveis para serem executadas pelos usuários */
    private createOptions() {
        this.options = new TituloReceberResourceOptions();
        // Imprimir
        this.options.printListagem = this.tituloReceberAuthGuardService.canPrintListagem();
    }

    private setStorage() {
        // Filter
        this.tituloReceberFilterStorageService.set(this.filterStorageKey, this.filter);
    }

    /** Seta os filtros padrões */
    private setDefaultFilters(force = false) {
        if (!this.tituloReceberFilterStorageService.hasFilter(this.filterStorageKey) || force) {
            // Periodicidade todo período
            this.tituloReceberFilter.setTodoPeriodo();
        }
    }

    private initFilter() {
        this.filterInitialization.initialization.subscribe(
            isInitialized => {
                if (isInitialized) {
                    this.tituloReceberFilterStorageService.applyFilter(this.filterStorageKey, this.filter);
                    this.setDefaultFilters();

                    setTimeout(() => {
                        this.search();
                    }, 0);
                }
            }
        );
    }

    /** Ao alterar a perspectiva da pesquisa */
    onChangePerspectiva(perspectiva: number) {
        this.filter.perspectiva = perspectiva;
        this.tituloReceberFilter.setTodoPeriodo();

        setTimeout(() => this.onFilterChange(), 0);
    }

    /** Quando o filtro é alterado */
    onFilterChange() {
        if (!this.filterInitialization.isInitialized()) {
            return;
        }
        this.search();
    }

    /** Ao limpar o filtro */
    onFilterCleaned() {
        this.setDefaultFilters(true);
        setTimeout(() => this.search(), 0);
    }

    search() {
        // Pessoas
        this.filter.idsPessoas = this.idsPessoasFilter;

        this.setStorage();
        this.table?.search();
    }

    refresh() {
        this.table?.refresh();
    }

    insert() {
        this.formModal.insert();
    }

    /** Realiza a impressão da listagem dos títulos a receber */
    printListagem() {
        // Obtendo o orderby da tabela
        let orderBy = 3; // Data de Vencimento
        let orderByDir = 'asc';

        const dataTableOrder = this.table?.dataTable.order() as Array<any>;
        if (dataTableOrder && dataTableOrder.length > 0) {
            const order = dataTableOrder[0];
            if (order) {
                orderBy = order[0];
                orderByDir = order[1];
            }
        }

        // Imprimindo
        this.tituloReceberReportHttpService.printListagem(this.filter, orderBy, orderByDir)
            .then(() => {})
            .catch(() => {});
    }

    /** Abre modal para visualizar o título a receber */
    visualizarTitulo(entity: TituloReceberSearch) {
        if (!entity) {
            return;
        }
        this.formModal.visualizar(entity.id);
    }

    ngOnDestroy(): void {
        this.tituloReceberFilterStorageService.remove(this.filterStorageKey);
    }
}
